import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { NpAppLayoutService, NpAuthChildGuard, NpBreadcrumbService, NpPathResolver, NpUserLoginService } from '@newpla/common';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppPathResolver } from '@sls-nova/shared-admin/nova-admin-core/config/app-path-resolver';
import { NpxLoginService } from '../../../newpla-npx-ng17/src/_core/auth/npx-login-service';
import { NpLocaleService } from '../../../newpla-npx-ng17/src/_core/locale/np-locale.service';
import { NpLocaleProvider } from '../../../newpla-npx-ng17/src/_core/locale/np-locale-provider';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';

import "@grapecity/wijmo.cultures/wijmo.culture.ko";
import * as wjcCore from '@grapecity/wijmo';


import { registerLocaleData } from '@angular/common';
import localeKo from '@angular/common/locales/ko';

import { environment } from '../environments/environment';
import { NpxHttpAuthInterceptor } from '../../../newpla-npx-ng17/src/_core/auth/npx-http-auth-interceptor.service';
import { COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NP_THEME_ITEMS, SLS_NOVA_ENV } from 'sls-nova-shared';


// wijmo
wjcCore.setLicenseKey(environment.wijmoLicenseKey);
wjcCore.changeCulture('ko');

registerLocaleData(localeKo);

function initializeApp(npUserLoginService: NpUserLoginService) {
  return async () => {

    await npUserLoginService.initialize().then(res => {
      console.log('initializeApp');
    })
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    //
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    // Newpla Default
    NpAuthChildGuard, AppPathResolver, NpxLoginService,
    // APP_LAY_OUT
    NpAppLayoutService, NpBreadcrumbService,
    { provide: NpPathResolver, useExisting: AppPathResolver },
    { provide: NpUserLoginService, useExisting: NpxLoginService },
    // LOCALE
    NpLocaleService, NpLocaleProvider,
    // APP CONFIG
    { provide: APP_INITIALIZER, useFactory: initializeApp, multi: true, deps: [NpUserLoginService] },
    { provide: HTTP_INTERCEPTORS, useClass: NpxHttpAuthInterceptor, multi: true },
    { provide: COMPOSITION_BUFFER_MODE, useValue: false },
    // 화주사 테마 목록 (NpThemeService 가 테마 메뉴 맨 위에 두고, 테마를 고른 적이 없으면 첫 번째 테마를 적용)
    { provide: NP_THEME_ITEMS, useValue: environment.themes },
    // 화주사별 환경 값. 공유 라이브러리는 environment를 직접 읽지 않고 이 토큰으로 받는다 (OVW-ARC-003 3.1)
    { provide: SLS_NOVA_ENV, useValue: environment },
    provideRouter(routes),

  ]
};
